/**
 * The Tafo app for Windows (desktop/, Electron) shows this till and prints the shop's jobs (ADR 0010).
 * Its preload script gives the page this small bridge; in a normal browser it is missing.
 */
export interface TafoDesktop {
  /** The version of the Tafo app for Windows ("1.0.0"). */
  version: string;
  /** This till's device token, so the app can fetch and report print jobs; null after unpairing. */
  setDeviceToken: (token: string | null) => void;
}

declare global {
  interface Window {
    tafoDesktop?: TafoDesktop;
  }
}

/** The Tafo app for Windows around this page, or null in a normal browser. */
export function desktopApp(): TafoDesktop | null {
  return typeof window === "undefined" ? null : (window.tafoDesktop ?? null);
}
